import React from 'react';

import Group from '@lightspeed/cirrus-group';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/cirrus-modal';
import Text from '@lightspeed/cirrus-text';
import { Button } from '@lightspeed/flame/Button';
import axios from 'axios';
import { withFormik } from 'formik';
import get from 'lodash/get';

const SyncStockLevelsModal = ({ handleSubmit, isSubmitting, onClose }) => (
  <Modal className="cirrus" isOpen onRequestClose={onClose}>
    <ModalHeader onCloseClicked={onClose}>Sync eCom stock levels</ModalHeader>
    <ModalBody>
      <Text body color="gray">
        Are you sure you want to <strong>sync eCom stock levels</strong>?
      </Text>
    </ModalBody>
    <ModalFooter>
      <Group className="cr-justify-end">
        <Button onClick={onClose}>No</Button>
        <Button variant="secondary" fill loading={isSubmitting} onClick={handleSubmit}>
          Yes
        </Button>
      </Group>
    </ModalFooter>
  </Modal>
);

const enhancedSyncStockLevelsModal = withFormik({
  handleSubmit: async (values, formikBag) => {
    formikBag.setSubmitting(true);

    const { accountId } = formikBag.props;

    try {
      const result = await axios.post(`/staff/accounts/${accountId}/ecom/sync-stock-levels`);

      formikBag.props.onConfirm({
        message: 'eCom stock levels sync started.',
        reload: true,
      });
    } catch (e) {
      window.alertUser(
        get(e, 'response.data.errors[0].detail') || 'An unexpected error has occurred.'
      );
    }

    formikBag.setSubmitting(false);
    formikBag.props.onClose();
  },
})(SyncStockLevelsModal);

export default enhancedSyncStockLevelsModal;
